import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue"
import { useNotification } from "@/hooks/useNotification"
import { ContractPayment, MoneyFragmentFragment } from "@/gql"
import { MoneyInputValue } from "@/components/widgets/input/MoneyInput.vue"
import Header from "@/modules/Missions/components/Payment/SetupPaymentHeader.vue"

export type PaymentFormValues = {
  paymentType?: ContractPayment | string
  percentage?: number | null
  deliverables: any[]
  clientPayment?: string | null
  amount?: {
    amount: number | null
    currency: string
  }
  description?: string | null
  name?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePaymentStructureForm',
  props: {
    totalPrice: null,
    form: null
  },
  emits: ["complete", "close", "back"],
  setup(__props: any, { emit }: { emit: ({
  (e: "complete", payments: PaymentFormValues[]): void
  (e: "close"): void
  (e: "back"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  totalPrice: MoneyInputValue | MoneyFragmentFragment
  form?: PaymentFormValues[]
}



const { addError } = useNotification()



const defaultFormObj = {
  paymentType: ContractPayment.InterimPayment,
  percentage: null,
  deliverables: [],
  clientPayment: null,
}

const getAmountFromPercentage = (percentage: number | null) => {
  if (!percentage) return 0
  return (parseFloat(props.totalPrice.amount as string) * percentage) / 100
}

const form = ref<PaymentFormValues[]>([])

const observer = ref(null)

const totalPercentage = computed(() => {
  return form.value.reduce((acc, curr) => acc + Number(curr.percentage), 0) || 0
})

const onSubmit = async () => {
  if (totalPercentage.value !== 100) return addError("Percentages must sum up to 100%")
  emit("complete", form.value)
}

onMounted(() => {
  if (props.form?.length) {
    form.value = props.form
  } else {
    for (let i = 0; i < 3; i++) {
      form.value.push(structuredClone(defaultFormObj))
    }
  }
})

return { __sfc: true,props, addError, emit, defaultFormObj, getAmountFromPercentage, form, observer, totalPercentage, onSubmit, Header }
}

})